import { useQuery } from '@tanstack/react-query'
import client from '@/ports/api-client'

const getListings = async tag => {
  const param =
    tag === 'livrent' ? 'exclude_tags=TRREB' : tag === 'integrations' ? 'tags=TRREB' : null
  const path = param ? `/listings?${param}` : '/listings'

  return await client.get(path)
}

const useMyListings = tags => {
  const tag = tags ?? 'all'
  const { data, isLoading } = useQuery({
    queryKey: ['my-listings', tag],
    queryFn: () => getListings(tag),
    staleTime: 30000
  })
  return { listings: data, isLoading }
}

export default useMyListings
